import styled from 'styled-components';

export const Container = styled.div`
  .checklist-percent {
    font-size: 12px;
    min-width: 34px;
  }

  .checklist-progress {
    height: 8px;
  }

  .checklist-item {
    border-radius: 6px;
    padding: 6px;
  }

  .checklist-item:hover {
    background: ${(props) => props.theme.$gray100};
  }

  .checklist-item-done {
    color: ${(props) => props.theme.$gray600};
    text-decoration: line-through;
  }

  .checklist-remove {
    opacity: 0.35;
    transition: opacity 0.15s ease;
  }

  .checklist-item:hover .checklist-remove,
  .checklist-remove:focus {
    opacity: 1;
  }

  .checklist-remove .material-icons {
    font-size: 16px;
  }
`;
